import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Le ultime domande che l'installatore ha davvero fatto.
 *
 * Richiesta di Umberto (24/07): in home non tre domande prestabilite ma le
 * ultime realmente poste — «più interattivo». La sua ragione è concreta: se ti
 * distrai in cantiere, la chat te la ritrovi e riprendi da dove eri.
 *
 * Restituisce null se non c'è storico: chi apre l'app la prima volta vede le
 * domande di esempio, che lì servono davvero.
 */
export function useUltimeDomande() {
  return useQuery({
    queryKey: ["ultime-domande"],
    staleTime: 30_000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from("messages")
        .select("content, created_at")
        .eq("role", "user")
        .order("created_at", { ascending: false })
        .limit(20);
      if (error) throw error;

      // Deduplica tenendo l'ordine: chi riformula la stessa domanda non deve
      // vedersela comparire tre volte.
      const viste = new Set<string>();
      const uniche: string[] = [];
      for (const m of data ?? []) {
        const testo = (m.content ?? "").trim();
        const chiave = testo.toLowerCase();
        if (!testo || testo.length < 8 || viste.has(chiave)) continue;
        viste.add(chiave);
        uniche.push(testo);
        if (uniche.length === 3) break;
      }
      return uniche;
    },
  });
}

/*
 * IL RIQUADRO NON C'E' PIU' (Davide, 27/08): «toglierei del tutto il "riprendi
 * da dove eri", bisogna avere piu' spazio libero sulla home». Occupava mezza
 * schermata per riproporre tre domande gia' fatte, mentre il pulsante
 * «Riprendi» riporta alla conversazione dove quelle domande vivono insieme
 * alle risposte.
 *
 * Il gancio qui sopra resta perche' serve ancora a una cosa sola: distinguere
 * chi apre l'app la prima volta - a lui, e solo a lui, si mostrano le domande
 * di esempio.
 */
